export default {
  data() {
    return {
      fenceCoordinatesList: null,
      polygonData: [],
    };
  },
  methods: {
    addNewHospitalFence: function () {
      const body = {
        hospitalId: this.hospitalId,
        fenceLocations: this.fenceCoordinatesList?.map(({ lat, lng }, index) => {
          return {
            pointNumber: index + 1,
            latitude: lat,
            longitude: lng,
          };
        }),
      };

      this.load.val = true;

      this.$store
        .dispatch('addNewHospitalFenceDispatch', body)
        .then(() => {
          if (this.$store.state.hospitalFenceModule.successFlag) {
            this.showSuccessAlert('فنس بیمارستان موردنظر کشیده شد.');
            this.closeHospitalFenceModal();
          } else {
            if (this.$store.state.hospitalFenceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.addNewHospitalFence();
                  this.closeHospitalFenceModal();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.hospitalFenceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.addNewHospitalFence();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.load.val = false));
    },
    getHospitalFencesList: function (hospitalId) {
      const params = { hospitalId };
      this.load.val = true;
      this.polygonData = [];
      this.$store
        .dispatch('getHospitalFencesListDispatch', params)
        .then(() => {
          if (this.$store.state.hospitalFenceModule.successFlag) {
            const data = this.$store.state?.hospitalFenceModule?.hospitalFencesList;
            // this.hospitalFencesList = data;
            if (data?.length) {
              this.polygonData = this.transformHospitalFencesList(data);
            } else {
              this.getHospitalFunction(hospitalId);
            }
          } else {
            if (this.$store.state.hospitalFenceModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getHospitalFencesList();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.hospitalFenceModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getHospitalFencesList();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.load.val = false));
    },
    transformHospitalFencesList: function (data) {
      return [...data]?.map(({ latitude, longitude }) => [latitude, longitude]);
    },
    showError: function () {
      this.snackText = this.$store.state.hospitalFenceModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
